(function () {
  var STORAGE_KEY = 'bnexo-treasure-found';
  var trigger = document.querySelector('[data-bnexo-treasure-trigger]');
  var modal = document.getElementById('bnexo-treasure-modal');
  if (!trigger || !modal) {
    return;
  }

  var copyBtn = document.getElementById('bnexo-treasure-copy');
  var codeEl = document.getElementById('bnexo-treasure-code');
  var code = codeEl ? codeEl.getAttribute('data-code') || codeEl.textContent.trim() : 'TRESOR5';
  var copyLabel = copyBtn ? copyBtn.querySelector('.bnexo-treasure-modal__copy-label') : null;
  var originalCopyText = copyLabel ? copyLabel.textContent : 'Copier';

  function openModal() {
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}

    var closeBtn = modal.querySelector('.bnexo-treasure-modal__close');
    if (closeBtn) {
      closeBtn.focus();
    }
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    trigger.focus();
  }

  trigger.addEventListener('click', function (event) {
    event.preventDefault();
    openModal();
  });

  modal.querySelectorAll('[data-bnexo-treasure-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', function () {
      function onCopied() {
        copyBtn.classList.add('is-copied');
        if (copyLabel) {
          copyLabel.textContent = 'Copié';
        }
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (copyLabel) {
            copyLabel.textContent = originalCopyText;
          }
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(onCopied).catch(function () {
          fallbackCopy();
        });
      } else {
        fallbackCopy();
      }

      function fallbackCopy() {
        var range = document.createRange();
        range.selectNodeContents(codeEl);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        try {
          document.execCommand('copy');
          onCopied();
        } catch (e) {}
        selection.removeAllRanges();
      }
    });
  }
})();
